const zoneListPayload = {
  country: '',
  state: '',
  city: '',
  port: '',
  postal: '',
  name: '',
  sectionInUse: '',
  type: '',
  pageNo: 1,
  pageSize: 10,
};

export default zoneListPayload;
